import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { OutboundParcelSchema } from "@redotech/redo-fulfillment-parcel-common/parcel";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createReturnLabel = {
  name: "createReturnLabel" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    shopperAddress: FulfillmentOrderAddressSchema,
    merchantAddress: FulfillmentOrderAddressSchema,
    parcel: OutboundParcelSchema,
  }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().optional(),
  }),
};
